export const TRAINING_LIST_SUCCESS = "TRAINING_LIST_SUCCES";
export const TRAINING_LIST_FAILURE = "TRAINING_LIST_FAILURE";

export const TRAINING_LIST_DETAILS_SUCCESS = "TRAINING_LIST_DETAILS_SUCCES";
export const TRAINING_LIST_DETAILS_FAILURE = "TRAINING_LIST_DETAILS_FAILURE";

export const MANUAL_TRAINING_SUCCESS = "MANUAL_TRAINING_SUCCESS";
export const MANUAL_TRAINING_FAILURE = "MANUAL_TRAINING_FAILURE";
